import React from "react";
import CurrencyFormat from "react-currency-format";
import { useTranslation } from "react-i18next";
import { useLanguageProvider } from "../../providers/LanguageProvider";
import { LinkValues } from "../../values/strings";

export const PrintableElementComponent = ({
  clientName,
  type,
  txid,
  token,
  symbol,
  amount,
  fee,
  state,
  creationDate,
  clientMobile = "",
  clientEmail = "",
  clientID = "",
  identityState = "",
  clientSignature = "",
  refund = "",
  term = "",
  apy = "",
  caption = "",
}) => {
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  return (
    <div
      style={{
        padding: 20,
        direction: lang.textDirection(),
        background: "#fff",
        color: "#000",
      }}
    >
      <table
        className="MsoTableGrid"
        dir=""
        border={1}
        cellSpacing={0}
        cellPadding={0}
        width="100%"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          border: "none",
          fontSize: 13,
        }}
      >
        <tbody>
          <tr>
            <td
              width="100%"
              colSpan={12}
              style={{
                width: "100%",
                border: "solid windowtext 1pt",
              }}
            >
              <table
                className="MsoTableGrid"
                border={0}
                cellSpacing={0}
                cellPadding={0}
                align="left"
                width="100%"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "none",
                }}
              >
                <tbody>
                  <tr style={{ height: "62.5pt" }}>
                    <td
                      width="9%"
                      style={{
                        width: "9.44%",
                        border: "none",
                        borderBottom: "solid windowtext 1pt",
                        background: "#f2f2f2",
                        padding: "10px",
                      }}
                    >
                      <p
                        className="MsoNormal"
                        align="center"
                        dir=""
                        style={{
                          marginBottom: "0in",
                          textAlign: "center",
                          lineHeight: "normal",
                          direction: "",
                          unicodeBidi: "embed",
                        }}
                      >
                        <b>
                          <span
                            lang="FA"
                            style={{
                              color: "black",
                            }}
                          >
                            {t("serviceProvider")}
                          </span>
                        </b>
                      </p>
                    </td>
                    <td
                      width="90%"
                      style={{
                        width: "90.56%",
                        borderTop: "none",
                        borderLeft:
                          lang.textDirection() === "ltr"
                            ? "solid windowtext 1pt"
                            : "none",
                        borderBottom: "solid windowtext 1pt",
                        borderRight:
                          lang.textDirection() === "ltr"
                            ? "none"
                            : "solid windowtext 1pt",
                        background: "white",
                        padding: "10px",
                      }}
                    >
                      <table
                        className="MsoTableGrid"
                        border={0}
                        cellSpacing={0}
                        cellPadding={0}
                        width="100%"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          border: "none",
                        }}
                      >
                        <tbody>
                          <tr style={{ height: "0.5in" }}>
                            <td
                              width="59%"
                              style={{
                                width: "59.64%",
                                padding: "10px",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span lang="AR-SA" style={{}}>
                                    {t("serviceProvider")}:{" "}
                                  </span>
                                </b>
                                <span lang="AR-SA" style={{}}>
                                  {t("app_name")}
                                </span>
                              </p>
                            </td>
                            <td
                              width="40%"
                              style={{
                                width: "40.36%",
                                padding: "10px",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span
                                    lang="AR-SA"
                                    style={{
                                      fontFamily: '"IRANYekan", sans-serif',
                                    }}
                                  >
                                    {t("tel")}:{" "}
                                  </span>
                                </b>
                                <span
                                  lang="AR-SA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                />
                                <span dir="LTR" />
                                <span
                                  dir="LTR"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  <span dir="LTR" />
                                  02191031916
                                </span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p
                        className="MsoNormal"
                        align="center"
                        dir=""
                        style={{
                          marginBottom: "0in",
                          textAlign: "center",
                          lineHeight: "normal",
                          direction: "",
                          unicodeBidi: "embed",
                        }}
                      >
                        <span
                          dir="LTR"
                          style={{ fontFamily: '"IRANYekan", sans-serif' }}
                        ></span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      width="9%"
                      style={{
                        width: "9.44%",
                        border: "none",
                        background: "#f2f2f2",
                        padding: "10px",
                      }}
                    >
                      <p
                        className="MsoNormal"
                        align="center"
                        dir=""
                        style={{
                          marginBottom: "0in",
                          textAlign: "center",
                          lineHeight: "normal",
                          direction: "",
                          unicodeBidi: "embed",
                        }}
                      >
                        <b>
                          <span
                            lang="AR-SA"
                            style={{
                              fontFamily: '"IRANYekan", sans-serif',
                              color: "black",
                            }}
                          >
                            {t("serviceClient")}
                          </span>
                        </b>
                        <b>
                          <span
                            dir="LTR"
                            style={{
                              fontFamily: '"IRANYekan", sans-serif',
                              color: "black",
                            }}
                          ></span>
                        </b>
                      </p>
                    </td>
                    <td
                      width="90%"
                      style={{
                        width: "90.56%",
                        border: "none",
                        borderLeft:
                          lang.textDirection() === "ltr"
                            ? "solid windowtext 1pt"
                            : "none",
                        borderRight:
                          lang.textDirection() === "ltr"
                            ? "none"
                            : "solid windowtext 1pt",
                        background: "white",
                        padding: "10px",
                      }}
                    >
                      <table
                        className="MsoTableGrid"
                        border={0}
                        cellSpacing={0}
                        cellPadding={0}
                        width="100%"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          border: "none",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              width="38%"
                              valign="top"
                              style={{
                                width: "38.56%",
                                padding: "10px",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",
                                  textAlign: "justify",
                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span
                                    lang="AR-SA"
                                    style={{
                                      fontFamily: '"IRANYekan", sans-serif',
                                    }}
                                  >
                                    {t("serviceClient")}:{" "}
                                  </span>
                                </b>
                                <span
                                  lang="AR-SA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  {clientName}
                                </span>
                                <span
                                  lang="FA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                ></span>
                              </p>
                            </td>
                            <td
                              width="25%"
                              valign="top"
                              style={{
                                width: "25.12%",
                                padding: "10px",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span
                                    lang="AR-SA"
                                    style={{
                                      fontFamily: '"IRANYekan", sans-serif',
                                    }}
                                  >
                                    {t("tel")}:{" "}
                                  </span>
                                </b>
                                <span
                                  lang="AR-SA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                />
                                <span dir="LTR" />
                                <span
                                  dir="LTR"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  <span dir="LTR" />
                                  {clientMobile}
                                </span>
                              </p>
                            </td>
                            <td
                              width="36%"
                              valign="top"
                              style={{
                                width: "36.32%",
                                padding: "10px",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span
                                    lang="AR-SA"
                                    style={{
                                      fontFamily: '"IRANYekan", sans-serif',
                                    }}
                                  >
                                    {t("email")}:{" "}
                                  </span>
                                </b>
                                <span
                                  lang="AR-SA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  {clientEmail}
                                </span>
                                <span
                                  dir="LTR"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                ></span>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td
                              width="38%"
                              style={{
                                width: "38.56%",
                                padding: "10px",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span
                                    lang="AR-SA"
                                    style={{
                                      fontFamily: '"IRANYekan", sans-serif',
                                    }}
                                  >
                                    {t("userId")}:{" "}
                                  </span>
                                </b>
                                <span
                                  lang="AR-SA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  {clientID}
                                </span>
                              </p>
                            </td>
                            <td
                              width="25%"
                              style={{
                                width: "25.12%",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <b>
                                  <span
                                    lang="AR-SA"
                                    style={{
                                      fontFamily: '"IRANYekan", sans-serif',
                                    }}
                                  >
                                    {t("identityState")}:{" "}
                                  </span>
                                </b>
                                <span
                                  lang="AR-SA"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  {identityState}
                                </span>
                              </p>
                            </td>
                            <td
                              width="36%"
                              style={{
                                width: "36.32%",
                              }}
                            >
                              <p
                                className="MsoNormal"
                                dir=""
                                style={{
                                  marginBottom: "0in",

                                  lineHeight: "normal",
                                  direction: "",
                                  unicodeBidi: "embed",
                                }}
                              >
                                <span
                                  dir="LTR"
                                  style={{
                                    fontFamily: '"IRANYekan", sans-serif',
                                  }}
                                >
                                  &nbsp;
                                </span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p
                        className="MsoNormal"
                        align="center"
                        dir=""
                        style={{
                          marginBottom: "0in",
                          textAlign: "center",
                          lineHeight: "normal",
                          direction: "",
                          unicodeBidi: "embed",
                        }}
                      >
                        <span
                          dir="LTR"
                          style={{ fontFamily: '"IRANYekan", sans-serif' }}
                        ></span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{ fontFamily: '"IRANYekan", sans-serif' }}
                  ></span>
                </b>
              </p>
            </td>
          </tr>
          <tr>
            <td
              width="100%"
              colSpan={12}
              style={{
                width: "100%",
                border: "solid windowtext 1pt",
                borderTop: "none",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{ fontFamily: '"IRANYekan", sans-serif' }}
                  >
                    {t("transactionId")}: {txid}
                  </span>
                </b>
              </p>
            </td>
          </tr>
          <tr>
            <td
              width="11%"
              style={{
                width: !term ? "16.66%" : "11.1%",
                border: "solid windowtext 1pt",
                borderTop: "none",
                background: "#f2f2f2",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("order")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              width="11%"
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",
                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("type")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              width="11%"
              colSpan={2}
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",
                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("currency")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              width="11%"
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",
                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("amount")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              colSpan={2}
              style={{
                width: "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",
                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
              hidden={!refund}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("refund")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              style={{
                width: "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
              hidden={!term}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("term")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              width="11%"
              colSpan={2}
              style={{
                width: "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
              hidden={!apy}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("apy")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("fee")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                background: "#f2f2f2",
                padding: "0in 0in 0in 0in",
                height: "34.15pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                      color: "black",
                    }}
                  >
                    {t("state")}
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{
                      fontFamily: '"IRANYekan", sans-serif',
                    }}
                  ></span>
                </b>
              </p>
            </td>
          </tr>
          <tr style={{ height: "58.45pt" }}>
            <td
              style={{
                width: !term ? "16.66%" : "11.1%",
                border: "solid windowtext 1pt",
                borderTop: "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span dir="" />
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  <span dir="" />1
                </span>
              </p>
            </td>
            <td
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {type}
                </span>
              </p>
            </td>
            <td
              colSpan={2}
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {token}
                </span>
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  (
                </span>
                <span
                  dir="LTR"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {symbol}
                </span>
                <span dir="" />
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  <span dir="" />)
                </span>
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                ></span>
              </p>
            </td>
            <td
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span dir="LTR" />
                <span
                  dir="LTR"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  <span dir="LTR" />

                  <CurrencyFormat
                    value={amount}
                    displayType="text"
                    thousandSeparator={true}
                  />
                </span>
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                ></span>
              </p>
            </td>
            <td
              width="11%"
              colSpan={2}
              style={{
                width: "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
              hidden={!refund}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {refund}
                </span>
              </p>
            </td>
            <td
              width="11%"
              style={{
                width: "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
              hidden={!term}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span dir="LTR" />
                <span
                  dir="LTR"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  <span dir="LTR" />
                  {term}
                </span>
              </p>
            </td>
            <td
              width="11%"
              colSpan={2}
              style={{
                width: "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
              hidden={!apy}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span dir="LTR" />
                <span
                  dir="LTR"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  <span dir="LTR" />
                  {apy}
                </span>
                <span dir="" />
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  <span dir="" />%
                </span>
              </p>
            </td>
            <td
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {fee}
                </span>
              </p>
            </td>
            <td
              style={{
                width: !term ? "16.66%" : "11.12%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "0in 0in 0in 0in",
                height: "58.45pt",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {state}
                </span>
              </p>
            </td>
          </tr>
          <tr style={{ height: "36.85pt" }}>
            <td
              width="100%"
              colSpan={12}
              style={{
                width: "100%",
                border: "solid windowtext 1pt",
                borderTop: "none",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{ fontFamily: '"IRANYekan", sans-serif' }}
                  >
                    {t("description")}:
                  </span>
                </b>
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {caption}
                </span>
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              width="100%"
              colSpan={12}
              style={{
                width: "100%",
                border: "solid windowtext 1pt",
                borderTop: "none",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    lang="AR-SA"
                    style={{ fontFamily: '"IRANYekan", sans-serif' }}
                  >
                    {t("attention")}:
                  </span>
                </b>{" "}
                <br />
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {t("dialogRebixSavingContractAttentions")}
                </span>
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                ></span>
              </p>
            </td>
          </tr>
          <tr style={{ pageBreakInside: "avoid" }}>
            <td
              width="25%"
              colSpan={!term ? 2 : 3}
              valign="top"
              style={{
                width: "25%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                borderBottom: "solid windowtext 1pt",
                borderRight:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {t("serviceProviderSignature")}:
                </span>
              </p>
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  &nbsp;
                </span>
              </p>
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <b>
                  <span
                    dir="LTR"
                    style={{ fontFamily: '"IRANYekan", sans-serif' }}
                  >
                    <img
                      width={180}
                      height={83}
                      src={LinkValues.images.company.signature.fa()}
                    />
                  </span>
                </b>
                <b>
                  <span
                    lang="AR-SA"
                    style={{ fontFamily: '"IRANYekan", sans-serif' }}
                  ></span>
                </b>
              </p>
            </td>
            <td
              width="25%"
              colSpan={!term ? 2 : 3}
              valign="top"
              style={{
                width: "25%",
                border: "none",
                borderBottom: "solid windowtext 1pt",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {t("providedServiceDate")}:
                </span>
              </p>
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{
                    fontFamily: '"IRANYekan", sans-serif',
                    color: "#4472c4",
                  }}
                >
                  &nbsp;
                </span>
              </p>
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span dir="LTR" />
                <span
                  dir="LTR"
                  style={{
                    fontFamily: '"IRANYekan", sans-serif',
                    color: "#4472c4",
                  }}
                >
                  <span dir="LTR" />
                  {creationDate}
                </span>
                <span
                  dir="LTR"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                ></span>
              </p>
            </td>
            <td
              width="25%"
              colSpan={!term ? 1 : 3}
              valign="top"
              style={{
                width: "25%",
                border: "none",
                borderBottom: "solid windowtext 1pt",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {t("providedServiceTime")}:
                </span>
              </p>
              <p
                className="MsoNormal"
                dir=""
                style={{
                  marginBottom: "0in",

                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  &nbsp;
                </span>
              </p>
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{
                    fontFamily: '"IRANYekan", sans-serif',
                    color: "#4472c4",
                  }}
                >
                  ---
                </span>
              </p>
            </td>
            <td
              width="25%"
              colSpan={!term ? 3 : 3}
              valign="top"
              style={{
                width: "25%",
                borderTop: "none",
                borderLeft:
                  lang.textDirection() === "ltr"
                    ? "none"
                    : "solid windowtext 1pt",
                borderBottom: "solid windowtext 1pt",

                borderRight:
                  lang.textDirection() === "ltr"
                    ? "solid windowtext 1pt"
                    : "none",
                padding: "10px",
              }}
            >
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {t("serviceClientSignature")}:
                </span>
              </p>
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  lang="AR-SA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  &nbsp;
                </span>
              </p>
              <p
                className="MsoNormal"
                align="center"
                dir=""
                style={{
                  marginBottom: "0in",
                  textAlign: "center",
                  lineHeight: "normal",
                  direction: "",
                  unicodeBidi: "embed",
                }}
              >
                <span
                  dir="LTR"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                >
                  {(clientSignature && (
                    <img width={94} height={85} src={clientSignature} />
                  )) ||
                    t("errorSignatureNotFound")}
                </span>
                <span
                  lang="FA"
                  style={{ fontFamily: '"IRANYekan", sans-serif' }}
                ></span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
